import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts'
import { MutableRefObject } from 'react'
import { ReadingData } from '../lib/hooks/api'

// data format example
// const data = [
//   {
//     name: 'Thurs, 24th Feb',
//     uv: 40,
//     a: 53,
//     b: 90,
//     pv: 24,
//     amt: 2400,
//   },
// ]

export default function Chart({
  data,
  refForDownload,
  showWeather,
}: {
  data: ReadingData
  refForDownload: MutableRefObject<unknown>
  showWeather: boolean
}) {
  const CustomizedAxisTick = ({
    x,
    y,
    payload,
  }: {
    x: number
    y: number
    payload: { value: string; index: number }
  }) => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={5} textAnchor="middle" fill="#666">
          {payload.value}
        </text>
        {showWeather && data?.grouped[payload.index]?.weatherIcon && (
          <image
            x={-35}
            y={15}
            href={`http://openweathermap.org/img/wn/${
              data?.grouped[payload.index]?.weatherIcon
            }@2x.png`}
            height="70"
            width="70"
          />
        )}
      </g>
    )
  }
  return (
    <div className="chart-bar">
      <BarChart
        width={1400}
        height={showWeather ? 550 : 500}
        data={data.grouped}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: showWeather ? 70 : 20,
        }}
        barCategoryGap={31}
        barGap={10}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref={refForDownload as any}
      >
        <CartesianGrid strokeDasharray="90 0 " vertical={false} />
        <XAxis
          dataKey="time"
          tickMargin={11}
          tickLine={true}
          tick={CustomizedAxisTick}
        />
        <YAxis minTickGap={40} />

        {data.barKeys.map((val, i) => (
          <>
            <Bar
              key={i}
              dataKey={val}
              fill="#E92C20"
              radius={[10, 10, 0, 0]}
              barSize={12}
            />
          </>
        ))}
        {data.barKeys.length < 35 && <Tooltip />}
      </BarChart>
    </div>
  )
}
